export default __webpack_public_path__ + "static/media/bf1.73f2775d.png";